import LangEnum from '../../../../../lang/LangEnum';
import { IMedia } from '../../../../../lib/MediasLib';
import { CatalogCardVariantKey } from '../../../../../modules/catalogs/products/v2/sizing/catalogCardColumns.types';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import Checkbox from '../../../../v2/form/Checkbox/Checkbox';
import ProductCardMedia from '../../../ProductCardMedia';
import ProductTagsRenderer from '../../../ProductTagsRenderer';
import { ProductTag } from '../../../hooks/useGetProductTagGroups';
import { CatalogItemRelations } from '../../ProductCard/types/productCard.types';
import {
  CHECKBOX_REVEAL_CLASS,
  TAG_HIDE_CLASSNAME,
  useProductCardV2Styles,
} from '../productCardV2.styles';
import { ProductCardV2Selection } from '../types/productCardV2.types';

interface ProductCardV2MediaProps {
  entityRelations: CatalogItemRelations;
  tags: ProductTag[];
  productName: string;
  medias?: IMedia[];
  catalogId?: string;
  selection?: ProductCardV2Selection;
  size?: CatalogCardVariantKey;
}

const ProductCardV2Media = ({
  entityRelations,
  tags,
  productName,
  medias,
  catalogId,
  selection,
  size,
}: ProductCardV2MediaProps) => {
  const { classes, cx } = useProductCardV2Styles({ size });
  const { translate } = useTranslation();

  return (
    <div className={classes.mediaContainer}>
      <ProductCardMedia
        catalogId={catalogId}
        bottomTags={null}
        medias={medias}
        entityRelations={entityRelations}
        overlay={
          <div className={classes.tagsOverlay}>
            {selection && (
              <div
                className={cx(
                  classes.checkboxWrapper,
                  CHECKBOX_REVEAL_CLASS,
                  selection.isSelected && classes.checkboxWrapperVisible,
                )}
              >
                <Checkbox
                  size="small"
                  className={classes.checkbox}
                  checked={selection.isSelected}
                  disabled={selection.isLocked}
                  onChange={selection.onToggle}
                  onClick={(event) => event.stopPropagation()}
                  slotProps={{
                    input: {
                      'aria-label': translate(LangEnum.CATALOGS_MASS_ACTIONS_SELECT_PRODUCT, {
                        name: productName,
                      }),
                    },
                  }}
                />
              </div>
            )}
            {tags.length > 0 && !selection?.isSelected && (
              <div className={cx(classes.tagsGroup, selection && TAG_HIDE_CLASSNAME)}>
                <ProductTagsRenderer tags={tags} variant="overlay" useSuffix />
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};

export default ProductCardV2Media;
